import {
  BooleanFlag,
  PercentageRollout,
  UserInList,
  UserSignedUpAfter,
} from "./checks";


const featureSwitches = {
  REACT_APP_ANNUAL_PLANS_USERS: UserInList,
  REACT_APP_ANNUAL_PLANS_NEW_SIGNUPS_AFTER: UserSignedUpAfter,
  REACT_APP_API_PLAYGROUND_USERS: UserInList,
  REACT_APP_CANCELLATION_SURVEY_USERS: UserInList,
  REACT_APP_PF_CANCELLATION_SURVEY_USERS: UserInList,
  REACT_APP_NEW_SUBSCRIPTION_DIALOGS_BILLING_ADDRESS_USERS: UserInList,
  REACT_APP_NEW_SUBSCRIPTION_DIALOGS_PAYMENT_SOURCES_USERS: UserInList,
  REACT_APP_NEW_BILLING_PAGE_PILOT_USERS: UserInList,
  REACT_APP_USE_NEW_API_KEY_MANAGEMENT_DIALOGS: BooleanFlag,
  REACT_APP_USE_REBRAND_2026: BooleanFlag,
  REACT_APP_PRICING_TABLE_SHOW_FREE_PLAN: PercentageRollout,
} as const;

export type FeatureSwitch = keyof typeof featureSwitches;

export const FeatureSwitches = Object.fromEntries(
  Object.entries(featureSwitches).map(([ key, Ctor ]) => [ key, new Ctor(key) ])
) as {
  [ K in FeatureSwitch ]: InstanceType<typeof featureSwitches[K]>;
};
